import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { CreatePinCode, PinCode, PinCodeListResponse, PinCodeQueryParams, UpdatePinCode } from '@frontend/pin-code/types';

export class PinCodeClient extends APIClient {
    public static readonly endpoint = '/pin-code-api/v1';

    public static async fetchPinCodes(queryParams?: ApiQueryParams<PinCodeQueryParams>): Promise<PinCodeListResponse> {
        return await this.apiPaginated<PinCodeListResponse, PinCodeQueryParams>(`${this.endpoint}/pin-codes`, queryParams);
    }

    public static async resolvePinCodes(ids: string[], field: string = 'id'): Promise<PinCodeListResponse> {
        return this.resolve<PinCodeListResponse>(`${this.endpoint}/pin-codes`, ids, field);
    }

    public static async deletePinCodes(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/pin-codes-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async postPinCode(accountId: string, pinCode: CreatePinCode): Promise<PinCode> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/pin-codes`, pinCode);
        return await this.handleResponse<PinCode>(response);
    }

    public static async fetchPinCode(accountId: string, pinCodeId: string): Promise<PinCode> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/pin-codes/${pinCodeId}`);
        return await this.handleResponse<PinCode>(response);
    }

    public static async patchPinCode(accountId: string, pinCodeId: string, pinCode: UpdatePinCode): Promise<PinCode> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/pin-codes/${pinCodeId}`, pinCode);
        return await this.handleResponse<PinCode>(response);
    }

    public static async deletePinCode(accountId: string, pinCodeId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/pin-codes/${pinCodeId}`);
        return await this.handleVoidResponse(response);
    }
}
